import { createSlice } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { ErrorMessage, SuccessMessage, spareSuccess } from "src/constants/Constant";

interface FetchSpare {
    productNumber: string,
    partNumber: string,
    bscPartNumber: string,
    BSUSNumber: string,
    description: string,
    salesPrice: string,
    spImageUrl: any,
    image: any,
    id?: number

}
interface FetchSpareUpload {
    status: boolean,
    message: string,
}
interface FetchSpareUploadStatus {
    completed: boolean,
    uploaded: number,
    total: number,
    completedOn: string,
    error: null,
}

interface ImageSearchResponse {
    status: string;
    message: string;
    data: {
        count: string;
        result: FetchSpare[];
    };
}

export interface SpareState {
    spareData: {
        isloading: boolean,
        status: boolean,
        message: string,
        data: {
            count: string,
            result: FetchSpare[]
        }
    },
    spareUpload: {
        isloading: boolean,
        data: FetchSpareUpload,
        isError: boolean
    },
    spareUploadStatus: {
        isloading: boolean,
        status: boolean,
        message: string,
        data: FetchSpareUploadStatus[]
    },

    spareImageUpload: {
        isloading: boolean,
        status: string,
        message: string
    },
    pagination: {
        max: string | number,
        limit: any,
        currentPage: any,
        data: {
            count: string,
            result: Array<FetchSpare>
        }
    },
    AlertMessageState: {
        show: boolean;
        type: string;
        message: string;
        showModal: boolean;
    },
    StatusMessageState: {
        loading: boolean;
        show: boolean;
        message: string;
        status:boolean;
        data: {
            completed: boolean
        }
    },
    productStateDelete:{
        items:any[],
        loading:boolean,
        error:string | null,
    },
    imageSearch: {
        isloading: boolean;
        data: ImageSearchResponse | null;
        error: string | null;
    };
    deletedSpares: {
        isloading: boolean;
        data: {
            count: string;
            result: FetchSpare[];
        } | null;
        error: string | null;
    };

}
const initialState: SpareState = {
    spareData: {
        isloading: true,
        status: false,
        message: '',
        data: {
            count: '',
            result: []
        }
    },
    spareUpload: {
        isloading: false,
        data: null,
        isError: false
    },
    spareUploadStatus: {
        isloading: false,
        status: true,
        message: '',
        data: []
    },

    spareImageUpload: {
        isloading: false,
        status: '',
        message: ''
    },
    pagination: {
        max: 1,
        limit: 10,
        currentPage: 0,
        data: {
            count: '',
            result: [],
        },
    },
    AlertMessageState: {
        show: false,
        type: '',
        message: '',
        showModal: false
    },
    StatusMessageState: {
        loading: true,
        show: true,
        message: '',
        status: false,
        data: {
            completed: false
        }
    },
    productStateDelete: {
        items: [],
        loading: false,
        error: null,
    },
    imageSearch: {
        isloading: false,
        data: null,
        error: null,
    },
    deletedSpares: {
        isloading: false,
        data: null,
        error: null,
    }
}

const Slice = createSlice({
    name: 'spare',
    initialState,
    reducers: {
        spareReceived: (state, action) => {
            state.spareData = action.payload;
            state.spareData = {
                ...state.spareData,
                isloading: false
            }
        },
        spareIsLoading(state) {
            state.spareData.isloading = true;
        },
        spareUplIsLoading(state) {
            state.spareUpload.isloading = true;
        },
        spareImageUplIsLoading(state) {
            state.spareImageUpload.isloading = true;
        },
        GetSpareError(state, action) {
            state.spareData = {
                ...state.spareData,
                isloading: false,
                data: action.payload
            };
        },
        spareUploaded: (state, action) => {
            state.spareUpload = {
                ...state.spareUpload,
                isloading: false,
                isError: false,
                data: action.payload
            };

        },
        spareStatusUploadLoading(state) {
            state.spareUploadStatus.isloading = true;
        },
        spareStatusUpload: (state, action) => {
            state.spareUploadStatus = {
                ...state.spareUploadStatus,
                isloading: false,
                status: action.payload.status,
                message: action.payload.message,
                data: action.payload.data
            };

        },

        spareImageUpdate(state, action) {
            state.spareImageUpload = action.payload;
            state.spareImageUpload = {
                ...state.spareImageUpload,
                isloading: false
            };
        },
        spareUploadedError(state, action) {
            state.spareUpload = {
                ...state.spareUpload,
                isloading: false,
                data: action.payload
            };
        },
        spareStatusUploadError(state, action) {
            state.spareUploadStatus = {
                ...state.spareUploadStatus,
                isloading: false,
                status: action.payload.status,
                message: action.payload.message,
                data: action.payload.data
            };
        },
        spareImageError(state, action) {
            state.spareImageUpload = action.payload;
            state.spareImageUpload = {
                ...state.spareImageUpload,
                isloading: false
            };
        },
        paginationItem(state, action) {
            state.pagination = action.payload;
            state.pagination.limit = 10;
        },
        clearData(state) {
            state.spareUpload.data.status = false
        },
        showAlertMessage(state, action) {
            state.AlertMessageState = {
                show: true,
                type: action.payload.type,
                message: action.payload.message,
                showModal: action.payload.showModal,
            };
        },
        showStatusMessageLoading(state) {
            state.StatusMessageState.loading = true
        },
        showStatusMessageAfterLoading(state) {
            state.StatusMessageState.loading = false
        },
        showStatusMessage(state, action) {
            state.StatusMessageState = {
                ...state.StatusMessageState,
                loading: false,
                show: true,
                status:true,
                message: action.payload.message,
                data: action.payload.data
            };
        },
        showStatusMessageError(state, action) {
            state.StatusMessageState = {
                ...state.StatusMessageState,
                loading: false,
                status:false,
                message: action.payload.message
            };
        },
        clearSpareData(state) {
            state.spareData.status = false;
            state.spareData.data.result = [];
        },
        clearAlertMessage(state) {
            state.AlertMessageState = {
                show: false,
                type: null,
                message: null,
                showModal: false,
            };
        },
        clearStatusMessageData(state) {
            state.StatusMessageState = {
                loading: false,
                message: 'Message cleared',
                data: null,
                status:false,
                show: false
            };
        },
         setLoader: (state, action) => {
              state.productStateDelete.loading = action.payload;
            },
            setErrors: (state, action) => {
              state.productStateDelete.error = action.payload;
            },
                removeProduct: (state, action) => {
              // Remove from spareData to ensure UI updates immediately
              if (state.spareData.data.result) {
                const idToDelete = typeof action.payload === 'string' ? Number.parseInt(action.payload) : action.payload;
                state.spareData.data.result = state.spareData.data.result.filter(
                  (spare) => spare.id !== idToDelete
                );
                // Update count
                const currentCount = Number.parseInt(state.spareData.data.count) || 0;
                state.spareData.data.count = Math.max(0, currentCount - 1).toString();
              }
            },
        imageSearchLoading(state) {
            state.imageSearch.isloading = true;
            state.imageSearch.error = null;
        },
        imageSearchSuccess(state, action) {
            state.imageSearch.isloading = false;
            state.imageSearch.data = action.payload;
            state.imageSearch.error = null;
        },
        imageSearchFailure(state, action) {
            state.imageSearch.isloading = false;
            state.imageSearch.error = action.payload;
            state.imageSearch.data = null;
        },
        deletedSparesLoading(state) {
            state.deletedSpares.isloading = true;
            state.deletedSpares.error = null;
        },
        deletedSparesSuccess(state, action) {
            state.deletedSpares.isloading = false;
            state.deletedSpares.data = action.payload;
            state.deletedSpares.error = null;
        },
        deletedSparesFailure(state, action) {
            state.deletedSpares.isloading = false;
            state.deletedSpares.error = action.payload;
            state.deletedSpares.data = null;
        },
        addSparePartLoading(state) {
            state.spareUpload.isloading = true;
            state.spareUpload.isError = false;
        },
        addSparePartSuccess(state, action) {
            state.spareUpload.isloading = false;
            state.spareUpload.data = action.payload;
            state.spareUpload.isError = false;
        },
        addSparePartError(state, action) {
            state.spareUpload.isloading = false;
            state.spareUpload.isError = true;
            state.spareUpload.data = action.payload;
        },
        updateSparePartLoading(state) {
            state.spareUpload.isloading = true;
            state.spareUpload.isError = false;
        },
        updateSparePartSuccess(state, action) {
            state.spareUpload.isloading = false;
            state.spareUpload.data = action.payload;
            state.spareUpload.isError = false;
        },
        updateSparePartError(state, action) {
            state.spareUpload.isloading = false;
            state.spareUpload.isError = true;
            state.spareUpload.data = action.payload;
        },
    }

})

// Fetch Limit Users
export const FetchSpareData = (data: any) => async (dispatch: any) => {
    dispatch(Slice.actions.spareIsLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/spareparts?page=${data}`)
        dispatch(Slice.actions.spareReceived(res.data));
    } catch (err) {
        dispatch(Slice.actions.GetSpareError(err));
    }
}

// Fetch All Users for pagination
export const FetchAllSpare = () => async (dispatch: any) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/spareparts?size=all`)
        dispatch(Slice.actions.paginationItem(res.data))

    } catch (err) {
        dispatch(Slice.actions.GetSpareError(err));
    }
}

// Search Results
export const SearchSpare = (data: any, page: any) => async (dispatch: any) => {
    dispatch(Slice.actions.spareIsLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/spareparts?searchText=${data.trim()}&page=${page}`)
        dispatch(Slice.actions.spareReceived(res.data))

    } catch (err) {
        dispatch(Slice.actions.GetSpareError(err));
    }
}
// Search Results with pagination 
export const searchAllSpare = (data: any) => async (dispatch: any) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/spareparts?searchText=${data}&size=all`)
        dispatch(Slice.actions.paginationItem(res.data))

    } catch (err) {
        dispatch(Slice.actions.GetSpareError(err));
    }
}

// Upload Excel Data
export const uploadExcelData = (DatQ: any) => async (dispatch: any) => {
    dispatch(Slice.actions.spareUplIsLoading());
    try {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/spareparts/upload`, DatQ);
        dispatch(Slice.actions.spareUploaded(res.data))
        dispatch(Slice.actions.showAlertMessage({
            message: spareSuccess,
            type: SuccessMessage
        }));
        dispatch(Slice.actions.showStatusMessageAfterLoading());
        
    } catch (error) {
       
        dispatch(Slice.actions.spareUploadedError(error));
        dispatch(Slice.actions.showAlertMessage({
            message: error.message,
            type: ErrorMessage
        }));
        dispatch(Slice.actions.showStatusMessageError(error));
        
    }
}


export const UpdateSpareImageById = (data: any) => async (dispatch: any) => {
    dispatch(Slice.actions.spareImageUplIsLoading());
    try {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/spareParts/uploadsparepartimage?`, data);
        dispatch(Slice.actions.spareImageUpdate(res.data));
        dispatch(Slice.actions.showAlertMessage({
            message: "Sparepart image uploaded successfully",
            type: SuccessMessage
        }));

    } catch (err) {
        dispatch(Slice.actions.spareImageError(err));
        dispatch(Slice.actions.showAlertMessage({
            message: err.message,
            type: ErrorMessage
        }));
    }
}
//product delete
export const deleteProduct = (id: number) => async (dispatch: any) => {
  try {
    dispatch(Slice.actions.setLoader(true));
    await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/spareparts/${id}`
    );
    dispatch(Slice.actions.removeProduct(id));
    dispatch(Slice.actions.setLoader(false));
  } catch (error: any) {
    dispatch(Slice.actions.removeProduct(id));
    dispatch(Slice.actions.setErrors(error.response?.data || "Error deleting product"));
    dispatch(Slice.actions.setLoader(false));
  }
};

export const clearDataInfo = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearData())
}

export const clearSpareDataInfo = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearSpareData())
}

// Image Search API
export const searchByImage = (imageFile: File, newPageIndex: number) => async (dispatch: any) => {
   
    dispatch(Slice.actions.imageSearchLoading());
    try {
        const formData = new FormData();
        formData.append('file', imageFile);
        
        const res = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/products/search-by-image?size=all`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        
        dispatch(Slice.actions.imageSearchSuccess(res.data));
        
        const spareParts = res.data.data?.spareParts;
        if (Array.isArray(spareParts) && spareParts.length > 0 && spareParts[0].result) {
           
            const productData = spareParts[0];
            dispatch(Slice.actions.spareReceived({
                isloading: false,
                status: res.data.status,
                message: res.data.message,
                error: false,
                data: {
                    count: productData.count || 0,
                    result: productData.result || []
                }
            }));
           
        } else if (Array.isArray(spareParts) && spareParts.length > 0) {
           
            dispatch(Slice.actions.spareReceived({
                isloading: false,
                status: res.data.status,
                message: res.data.message,
                error: false,
                data: {
                    count: spareParts.length,
                    result: spareParts
                }
            }));
           
        } else {
           
            dispatch(Slice.actions.spareReceived({
                isloading: false,
                status: false,
                message: "No products found",
                error: false,
                data: { count: 0, result: [] }
            }));
        }
    } catch (err) {
       
        const errorMessage = err.response?.data?.message || 'Image search failed';
        dispatch(Slice.actions.imageSearchFailure(errorMessage));
        dispatch(Slice.actions.spareReceived({
            isloading: false, status: false, message: errorMessage, error: false,
            data: { count: 0, result: [] }
        }));
       
    }
};

// Fetch Deleted Spare Parts
export const fetchDeletedSpares = () => async (dispatch: any) => {
    dispatch(Slice.actions.deletedSparesLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/getdeletedspareparts?size=all`);
        dispatch(Slice.actions.deletedSparesSuccess(res.data.data));
    } catch (err) {
        dispatch(Slice.actions.deletedSparesFailure(err.response?.data?.message || 'Failed to fetch deleted spare parts'));
    }
};

export const restoreSpares = (spareIds: number[]) => async (dispatch: any) => {
    try {
        const res = await axios.patch(`${process.env.REACT_APP_BASE_URL}/restorespareparts`, {
            restoreSparePartsIds: spareIds
        });
        return res.data;
    } catch (err) {
        throw err.response?.data?.message || 'Failed to restore spare parts';
    }
};

// Add Spare Part
export const addSparePart = (formData: FormData) => async (dispatch: any) => {
    dispatch(Slice.actions.addSparePartLoading());
    try {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/spareparts`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        dispatch(Slice.actions.addSparePartSuccess(res.data));
        return res.data;
    } catch (err) {
        dispatch(Slice.actions.addSparePartError(err));
        throw err;
    }
};

// Update Spare Part
export const updateSparePart = (formData: FormData) => async (dispatch: any) => {
    dispatch(Slice.actions.updateSparePartLoading());
    try {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/spareparts/udpatesparepartsdetails`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        dispatch(Slice.actions.updateSparePartSuccess(res.data));
        return res.data;
    } catch (err) {
        dispatch(Slice.actions.updateSparePartError(err));
        throw err;
    }
};

export const clearAlertMessage = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearAlertMessage());
};
export const reducer = Slice.reducer;
export default Slice;